import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function VideoTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation(['common_ui']);

  const tabs = [
    { id: 'generation', label: t('common_ui:tabs.video.generation'), path: '/video-generation' },
    { id: 'lipsync', label: t('common_ui:tabs.video.lipsync'), path: '/video-lipsync' }
  ];

  const activeTab = location.pathname === '/video-lipsync' ? 'lipsync' : 'generation';

  return (
    <div className="p-4 border-b border-border-subtle">
      <nav className="flex space-x-8">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => navigate(tab.path)}
            className={`py-1 px-1 border-b-2 font-medium text-lg transition-colors ${activeTab === tab.id
              ? 'border-primary text-gray-50'
              : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-gray-300'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </nav>
    </div>
  );
}